import getCategoryDetailsFeaturedHeaderData from "./getCategoryDetailsFeaturedHeaderData";

export default (state) => Boolean(getCategoryDetailsFeaturedHeaderData(state));
